<h5>Filter Templates</h5>
<div class="edit-save-fitlers">
  <mat-form-field class="w-25 me-2">
    <mat-label>
      @if (loading) {
        Loading Filters...
      } @else if (!loading && savedFilters.length < 1) {
        No saved filters
      } @else {
        Saved Filters
      }
    </mat-label>
    <mat-select
      panelClass="saved-template-select"
      [disabled]="!savedFilters || savedFilters.length < 1"
      [(ngModel)]="currentSelectedSavedFilter"
      (selectionChange)="templateSelected($event)"
    >
      @if (savedUserFilters && savedUserFilters.length > 0) {
        <div class="saved-filter-user-title"><span>Your Filters</span></div>
        @for (filter of savedUserFilters; track $index) {
          <mat-option [value]="filter"
            >{{ filter.Name }}
            <button
              type="button"
              mat-icon-button
              (click)="
                deleteFilter($event, filter, savedUserFilters, null, $index)
              "
            >
              <mat-icon>delete</mat-icon>
            </button></mat-option
          >
        }
      }
      @if (savedManagerFilters && savedManagerFilters.length > 0) {
        <div class="saved-filter-manager-title"
          ><span>Manager Filters</span></div
        >
        @for (item of savedManagerFilters; track item) {
          <div class="saved-filter-manager-subtitle"
            ><span>{{ item.unit }} Filters</span></div
          >
          @for (filter of item.filters; track $index) {
            <mat-option [value]="filter"
              >{{ filter.Name }}
              @if (
                canSaveEditUnitFilters &&
                rights.includes('SaveManagerFilters') &&
                filter.UserID === userID
              ) {
                <button
                  type="button"
                  mat-icon-button
                  (click)="
                    deleteFilter(
                      $event,
                      filter,
                      savedManagerFilters,
                      item,
                      $index
                    )
                  "
                >
                  <mat-icon>delete</mat-icon>
                </button>
              }
            </mat-option>
          }
        }
      }
      @if (savedGlobalFilters && savedGlobalFilters.length > 0) {
        <div class="saved-filter-global-title"
          ><span>Filters Shared with You</span></div
        >
        @for (filter of savedGlobalFilters; track $index) {
          <mat-option [value]="filter"
            >{{ filter.Name }}
            @if (
              canSaveEditUnitFilters &&
              rights.includes('SaveGlobalFilters') &&
              filter.UserID === userID
            ) {
              <button
                type="button"
                mat-icon-button
                (click)="
                  deleteFilter($event, filter, savedGlobalFilters, null, $index)
                "
              >
                <mat-icon>delete</mat-icon>
              </button>
            }
          </mat-option>
        }
      }
      <mat-select-trigger>{{ newFilterName }}</mat-select-trigger>
    </mat-select>
  </mat-form-field>
  @if (!searchOnly) {
    <button
      type="button"
      matButton="elevated"
      color="primary"
      [disabled]="preparingSavedFilter()"
      (click)="launchFilterModal('save')"
    >
      @if (filterID) {
        Save/Update Filter
      } @else {
        Save New Filter
      }
    </button>
  }
</div>

<ng-template #manageFiltersDialog>
  @if (modalAction && modalAction === 'save') {
    <div mat-dialog-header>
      <h1>Save Filter</h1>
    </div>
    <div mat-dialog-content class="dialog-container">
      @if (
        filterID &&
        orgUnitFilterSelected &&
        userID !== currentSelectedSavedFilter.UserID
      ) {
        You cannot edit this shared filter since you did not create it. These
        settings will be saved as a new filter.
      }
      @if (
        filterID &&
        userID === currentSelectedSavedFilter.UserID &&
        ((orgUnitFilterSelected && canSaveEditUnitFilters) ||
          !orgUnitFilterSelected)
      ) {
        <mat-radio-group
          aria-label="Select an option"
          [formControl]="overwriteSaveControl"
          [required]="true"
          [(ngModel)]="saveMethod"
        >
          <mat-radio-button value="overwrite">
            Overwrite Currently Selected Filter
          </mat-radio-button>
          <mat-radio-button value="save">Save New Filter</mat-radio-button>
        </mat-radio-group>
        @if (
          overwriteSaveControl.hasError('required') &&
          overwriteSaveControl.touched
        ) {
          <mat-error> This field is required </mat-error>
        }
      }

      <div class="name-field-container">
        <mat-form-field class="w-100">
          <mat-label>Filter Name</mat-label>
          <input
            matInput
            type="text"
            [formControl]="newFilterNameControl"
            [(ngModel)]="newFilterName"
          />
          @if (newFilterNameControl.hasError('maxlength')) {
            <mat-error align="start">
              Name must be 50 characters or less
            </mat-error>
          }
          <mat-hint align="start">{{ newFilterName.length }} / 50</mat-hint>
          @if (newFilterName) {
            <button
              type="button"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="newFilterName = ''"
            >
              <mat-icon>close</mat-icon>
            </button>
          }
        </mat-form-field>
      </div>
      <div class="filter-list-container">
        @if (this.filtersFormatted && this.filtersFormatted.length > 0) {
          <h3>Currently Selected Field(s)</h3>
          <table class="w-100">
            <thead>
              <th>Filter</th>
              <th>Selection</th>
            </thead>
            <tbody>
              @for (filterItem of this.filtersFormatted; track filterItem) {
                <tr>
                  <td>{{ filterItem.label }}</td>
                  <td
                    [ngClass]="{
                      'date-invalid-selection':
                        filterItem.display === 'Invalid Date Selection' &&
                        invalidSave,
                    }"
                  >
                    {{
                      arrDeclaration.isArray(filterItem.display)
                        ? filterItem.display.join(', ')
                        : filterItem.display
                    }}
                  </td>
                </tr>
              }
            </tbody>
          </table>
        } @else {
          <h3>No Fields Selected</h3>
        }
      </div>
      @if (canSaveEditUnitFilters) {
        <div class="w-50">
          <div>Save Filter as...</div>
          <mat-radio-group
            [formControl]="unitTypeControl"
            [required]="true"
            [(ngModel)]="unitScope"
          >
            <mat-radio-button [value]="'user'">Personal</mat-radio-button>
            @if (rights.includes('SaveManagerFilters')) {
              <mat-radio-button [value]="'manager'">
                Managers Only
              </mat-radio-button>
            }
            <!-- TODO -->
            <!-- the following is a least invasive bug fix for dashboard specific grids and will be removed and expanded in the future. -->
            <!-- in the future there will be rights to control each radio and matching conditions around filters for each level. -->
            @if (
              rights.includes('SaveGlobalFilters') &&
              !(grid === 'RepBehavior' || grid === 'CaseExplorer')
            ) {
              <mat-radio-button [value]="'global'">All Users</mat-radio-button>
            }
          </mat-radio-group>
          @if (unitScope === 'manager' || unitScope === 'global') {
            <mat-form-field class="me-2 w-100 user-select">
              <mat-label>Unit</mat-label>
              <input
                type="text"
                matInput
                [placeholder]="'Unit'"
                [matAutocomplete]="autoUnit"
                [formControl]="unitSearchControl"
              />
              <mat-autocomplete
                #autoUnit="matAutocomplete"
                (optionSelected)="changeSelection($event)"
              >
                @for (opt of unitList; track opt.value) {
                  <mat-option value="{{ opt.value }}">
                    {{ opt.value }}: {{ opt.display }}
                  </mat-option>
                }
              </mat-autocomplete>
              <mat-hint>
                Note: Please enter a valid unit. Filter will be availble to
                users in the unit selected.
              </mat-hint>
            </mat-form-field>
          }
        </div>
      }
    </div>
    <div mat-dialog-actions class="row buttons">
      <button
        type="button"
        mat-raised-button
        style="margin-left: auto"
        (click)="close(); $event.preventDefault()"
      >
        Cancel
      </button>
      <button
        type="button"
        mat-raised-button
        style="margin-left: 10px"
        color="accent"
        [disabled]="isDisabled()"
        (click)="submitData('save'); $event.preventDefault()"
      >
        Save
      </button>
    </div>
  }
  <ngx-loading [show]="loading" [config]="{ fullScreenBackdrop: false }" />
</ng-template>
